var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polyline, _polygon6, _polygon7, _polygon8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobVexenShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #879fa0;\n      }\n\n      .cls-2 {\n        fill: #00bcb7;\n      }\n\n      .cls-3 {\n        fill: #f98fff;\n      }\n\n      .cls-4 {\n        fill: #9fbec1;\n      }\n\n      .cls-5 {\n        fill: #b4d1d6;\n      }\n\n      .cls-6 {\n        fill: aqua;\n      }\n\n      .cls-7 {\n        fill: #738d8e;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "494.99 393.87 454.26 399.99 369.51 399.99 369.51 327.85 494.99 346.7 494.99 393.87"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "516.61 311.91 217.05 347.5 118.66 382.92 441.73 382.92 516.61 311.91"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "436.24 395.6 157.39 395.6 118.14 382.39 439.34 382.39 436.24 395.6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "427.13 425.3 218.11 413.35 218.11 407.39 427.13 394.39 427.13 425.3"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "484.85 430.82 320.96 427.43 246.4 382.08 442.39 382.08 484.85 430.82"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "217.05 346.44 567.99 265.21 516.02 312.21"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "217.05 346.44 117.86 383.07 194.83 383.07 510.79 255.88 217.05 346.44"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "524.56 450.76 299.33 447.73 268.56 426.92 496.48 430.82 524.56 450.76"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "278.67 382.01 442.79 381.88 515.79 312.88 278.67 382.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobVexenShip);
export default __webpack_public_path__ + "static/media/mob-vexen-ship.636e78014388e25e5828249d68a27551.svg";
export { ForwardRef as ReactComponent };